import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import {ROLES} from '@/lib/auth/roles'
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import {advisersQueryOptions,} from '@/modules/advisers/advisers-table/hooks'
import {
  AdviserSearch,
  defaultFetchParamsAdviser,
  mergedAdviserSchema,
} from "@/types/route-search-schemas";
import {DataLoader} from '@/types/router-context'
import {PROFESSIONALS_PATH, PROFESSIONALS_URL} from "@/utils/urls";
import Advisers from "src/modules/professionals/professionals-table";

export const Route = createFileRoute(PROFESSIONALS_PATH)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): AdviserSearch => validateSearchWithDefaults(mergedAdviserSchema, search),
  loader: ({context: {queryClient}}: DataLoader) => {
    if (isCurrentPage(PROFESSIONALS_URL)) {
      return
    }
    return queryClient.prefetchQuery(advisersQueryOptions(defaultFetchParamsAdviser))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Home', path: '/'},
        {label: 'Advisers', path: PROFESSIONALS_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  },
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-left justify-center max-sm:p-5'}>
      <Authorisation
        roles={[
          ROLES.ROLE_VIEW_ADVISER,
          ROLES.ROLE_VIEW_FIRM,
        ]}
        permissions={[]}
        forbiddenFallback={<Unauthorized/>}
      >
        <Advisers/>
      </Authorisation>
    </div>
  )
}
